import { render, staticRenderFns } from "./ErrorMessage.vue?vue&type=template&id=1a4e2a2a&"
import script from "./ErrorMessage.vue?vue&type=script&lang=js&"
export * from "./ErrorMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a4e2a2a')) {
      api.createRecord('1a4e2a2a', component.options)
    } else {
      api.reload('1a4e2a2a', component.options)
    }
    module.hot.accept("./ErrorMessage.vue?vue&type=template&id=1a4e2a2a&", function () {
      api.rerender('1a4e2a2a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2u5XJyY7FrHdU/JS/comp/ErrorMessage.vue"
export default component.exports